<template>
  <Modal
    v-model="ProjectShow"
    :title="actionType === 'add' ? $t('message.workflow.createWorkflow') : $t('message.workflow.editorWorkflow')"
    :closable="false"
	:mask-closable="false"
	@on-visible-change="handleVisibleChange"
  >
    <Form
      :label-width="100"
      label-position="left"
      ref="projectForm"
      :model="workflowDataCurrent"
      :rules="formValid"
      v-if="workflowDataCurrent"
	>
      <FormItem
        :label="$t('message.workflow.workflowName')"
        prop="name">
        <Input
          v-model="workflowDataCurrent.name"
          :placeholder="$t('message.workflow.inputFlowName')"
        ></Input>
      </FormItem>
      <FormItem
        :label="$t('message.workflow.use')"
        prop="uses">
        <we-tag
          :new-label="$t('message.workflow.addUse')"
          :tag-list="workflowDataCurrent.uses"
          @add-tag="addTag"
          @delete-tag="deleteTag"
		></we-tag>
      </FormItem>
      <FormItem
        :label="$t('message.workflow.workflowDesc')"
        prop="projectDescipte">
        <Input
          v-model="workflowDataCurrent.description"
          type="textarea"
          :placeholder="$t('message.workflow.inputWorkflowDesc')"></Input>
      </FormItem>
    </Form>
	<!-- 调度配置 -->
	<ScheduleConfig
		ref="schedule-config"
		:current-cron="workflowDataCurrent.cronOutput || '0 * * ? * *'"
		@change-cron="changeCron"
	></ScheduleConfig>
    <div slot="footer">
      <Button
        type="text"
        size="large"
        @click="Cancel"
	  >{{$t('message.newConst.cancel')}}</Button>
      <Button
        type="primary"
        size="large"
        @click="Ok"
	  >{{$t('message.newConst.ok')}}</Button>
    </div>
  </Modal>
</template>

<script>
import tag from '@dss/js/component/tag/index.vue';

import ScheduleConfig from "@/component/data-development/schedule-config.vue";

import {isValidCron} from "cron-validator";

export default {
  components: {
    'we-tag': tag,
	ScheduleConfig
  },
  props: {
    workflowData: {
      type: Object,
      default: null,
    },
    addProjectShow: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ProjectShow: false,
      originBusiness: '',
	  //新增Crontab表达式
	  cronOutput: "",
	  originCron: ""
    };
  },
  computed: {
    workflowDataCurrent() {
      return this.workflowData || new Object();
    },
    formValid() {
      return {
        name: [
          { required: true, message: this.$t('message.newConst.enterName'), trigger: 'blur' },
          { message: `${this.$t('message.newConst.nameLength')}180`, max: 180 },
          { type: 'string', pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: this.$t('message.newConst.validNameDesc'), trigger: 'blur' },
        ],
      }
    }
  },
  watch: {
    addProjectShow(val) {
      this.ProjectShow = val;
      /* if (!val) {
          this.$refs.projectForm.resetFields();
      } */
    },
    ProjectShow(val) {
      if (val) {
        this.originBusiness = this.workflowDataCurrent.uses;
		
		this.cronOutput = this.originCron = this.workflowDataCurrent.cronOutput || "0 * * ? * *";
      }
      this.$emit('show', val);
    },
  },
  methods: {
    Ok() {
	  let cronOutput = this.cronOutput.split(" ");
	  
	  let dayOfWeek = cronOutput[cronOutput.length - 1];
	  
	  if(!isNaN(dayOfWeek)) {
		cronOutput[cronOutput.length - 1] = dayOfWeek - 1;
	  }
		
	  cronOutput = cronOutput.join(" ");
		
	  if(!isValidCron(cronOutput, {
		seconds: true,
		allowBlankDay: true
	  })) {
		return this.$Message.warning("请检查表达式的合法性");
	  }
		
      this.$refs.projectForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', {
			...this.workflowDataCurrent,
			// 增加Crontab表达式字段
			cronOutput: this.cronOutput
		  });
		  
          this.ProjectShow = false;
        } else {
          this.$Message.warning(this.$t('message.newConst.failedNotice'));
        }
      });
    },
    Cancel() {
      this.ProjectShow = false;
      this.workflowDataCurrent.uses = this.originBusiness;
	  
	  this.cronOutput = this.originCron;
    },
    addTag(label) {
      if (this.workflowDataCurrent.uses) {
        this.workflowDataCurrent.uses += `,${label}`;
      } else {
        this.workflowDataCurrent.uses = label;
      }
    },
    deleteTag(label) {
      const tmpArr = this.workflowDataCurrent.uses.split(',');
      const index = tmpArr.findIndex((item) => item === label);
      tmpArr.splice(index, 1);
      this.workflowData.uses = tmpArr.toString();
    },
	changeCron(value) {
		this.cronOutput = value;
	},
	handleVisibleChange() {
		let {
			ProjectShow,
			workflowDataCurrent
		} = this;
		
		if(ProjectShow) {
			this.$refs["schedule-config"].updateCron(workflowDataCurrent.cronOutput || "0 * * ? * *");
		}
	}
  }
};
</script>
